import React from "react";
import closeIcon from "../../../../assets/icons/closeIcon.svg";
import "./create-role.scss";
import icons from "../../../../assets/icons/icons";

interface RolesConfirmationPopupProps {
  isOpen: boolean;
  onClose: () => void;
  handleSaveChanges: (roleName?: string) => void;
}

const RolesCreationPopup: React.FC<RolesConfirmationPopupProps> = ({
  isOpen,
  onClose,
  handleSaveChanges,
}) => {
  const [roleName, setRoleName] = React.useState<string>("");
  const [error, setError] = React.useState<string>("");

  if (!isOpen) return null;

  const handleRoleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setRoleName(value);
  
    if (!value.trim()) {
      setError("Role name is required");
      return;
    }
  
    if (!/^[a-zA-Z\s]+$/.test(value)) {
      setError("Role name can only contain letters and spaces");
      return;
    }
  
    if (value.length < 3) {
      setError("Role name must be at least 3 characters long");
      return;
    }
  
    if (value.length > 50) {
      setError("Role name cannot exceed 50 characters");
      return;
    }
  
    setError("");
  };

  const handleManage = () => {
    if (!roleName.trim()) {
      setError("Role name is required");
      return;
    }
    setError("");
    handleSaveChanges(roleName.trim());
  };

  return (
    <div className="create-roles-popup-overlay">
      <div className="roles-create-popup">
        <div className="roles-create-popup-header">
          <h4 className="roles-create-popup-header-text">Create Role</h4>
          <img
            src={closeIcon}
            alt="icon"
            className="roles-create-popup-close-button"
            onClick={onClose}
          />
        </div>
        <div className="roles-create-popup-content">
          <div className="roles-create-popup-content-label-input">
            <div className="roles-create-popup-content-label">Role Name</div>
            <input
              type="text"
              className={`roles-create-popup-content-input ${error ? "input-error" : ""}`}
              placeholder="Enter role name"
              value={roleName}
              onChange={handleRoleNameChange}
            />
            {error && <div className="roles-create-popup-error">{error}</div>}
          </div>
        </div>
        <div className="roles-create-popup-content-info">
          <div className="roles-create-popup-content-label">
            <i className="fa fa-circle-info" />
          </div>
          <div className="roles-create-popup-content-info-text">
            Clicking 'Manage Role and Permissions' will take you to the User
            Roles & Permissions module to set access and controls for this role.
          </div>
        </div>
        <div className="roles-create-buttons">
          <button className="roles-create-cancel-button" onClick={onClose}>
            Close
          </button>
          <button
            className="roles-create-button"
            type="button"
            disabled={!roleName.trim() || !!error}
            onClick={handleManage}
          >
            Manage Role Permissions
            <img src={icons.ArrowRightIcon} alt="arrow" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default RolesCreationPopup;